import React, { ChangeEvent, ReactNode } from 'react';
import { get } from '@grubhubprod/umami-library/dist/nodash/get';
import classnames from 'classnames';
import {
  Flex,
  FormInput,
  Label,
  SvgCaretDown,
} from '@grubhubprod/gh-cookbook-react/dist';
import { IFormInputProps } from 'src/components/Input/Input';
import { FormInputContentWrapper } from 'src/components/common/FormInputContentWrapper/FormInputContentWrapper';

export interface ISelectProps extends IFormInputProps {
  children: ReactNode;
  name: string;
  onChange?: (event: ChangeEvent<HTMLSelectElement>) => void;
  disabled?: boolean;
}

export const Select = React.forwardRef<HTMLSelectElement, ISelectProps>(
  function selectElement(
    {
      label,
      id,
      name,
      error,
      children,
      subDescription,
      onChange,
      disabled,
      ariaLabel,
    },
    ref
  ) {
    const errorMessage = get(error, 'message');
    const hasError = !!errorMessage;
    return (
      <FormInput inputSize="medium" error={error} helperText={subDescription}>
        {label && <Label htmlFor={id}>{label}</Label>}
        <FormInputContentWrapper>
          <div className="selectContainer">
            <select
              className={classnames('select', {
                hasError,
              })}
              id={id}
              name={name}
              ref={ref}
              onChange={onChange}
              disabled={disabled}
              /* eslint-disable react/jsx-props-no-spreading */
              {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
            >
              {children}
            </select>
            <Flex
              height="100%"
              alignItems="center"
              className="caret"
              color="secondaryText"
            >
              <SvgCaretDown size="16px" />
            </Flex>
          </div>
        </FormInputContentWrapper>
      </FormInput>
    );
  }
);
